import { Link } from "react-router-dom";
import { Scissors, Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const NAV = [
  { to: "/use-cases/task-management-software", label: "Task management" },
  { to: "/compare/clickup", label: "Compare" },
  { to: "/blog", label: "Blog" },
  { to: "/pricing", label: "Pricing" },
  { to: "/help", label: "Help" },
];

export default function MarketingHeader() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const authed = !!user;
  return (
    <header className="border-b border-zinc-200 bg-white sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-5 md:px-10 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 sm:gap-3 shrink-0 min-w-0">
          <div className="w-9 h-9 bg-zinc-900 text-white flex items-center justify-center shrink-0">
            <Scissors className="w-4 h-4" strokeWidth={1.75} />
          </div>
          <div className="min-w-0">
            <div className="text-base font-semibold tracking-tight text-zinc-900 leading-none">BreakItDown</div>
            <div className="hidden sm:block text-[10px] uppercase tracking-[0.18em] text-zinc-400 mt-1 truncate">Break it down. Get it done.</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="text-sm text-zinc-600 hover:text-zinc-900 transition-colors whitespace-nowrap">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          {authed ? (
            <Link
              to="/app"
              className="text-xs uppercase tracking-[0.12em] font-medium px-3 sm:px-4 py-2 sm:py-2.5 bg-zinc-900 hover:bg-[#002FA7] text-white transition-colors whitespace-nowrap"
              data-testid="marketing-open-app"
            >
              Open app →
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="hidden sm:inline text-sm text-zinc-700 hover:text-zinc-900 px-3 py-2"
                data-testid="marketing-signin"
              >
                Sign in
              </Link>
              <Link
                to="/login"
                className="hidden min-[360px]:inline-flex items-center text-xs uppercase tracking-[0.12em] font-medium px-3 sm:px-4 py-2 sm:py-2.5 bg-zinc-900 hover:bg-[#002FA7] text-white transition-colors whitespace-nowrap"
                data-testid="marketing-cta-top"
              >
                Start free
              </Link>
            </>
          )}
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 text-zinc-700 -mr-2"
            aria-label="Menu"
            data-testid="marketing-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-zinc-200 px-5 py-4 grid gap-3 bg-white">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="text-sm text-zinc-700" onClick={() => setOpen(false)}>
              {n.label}
            </Link>
          ))}
          {!authed && (
            <Link to="/login" className="sm:hidden text-sm text-zinc-700 pt-2 border-t border-zinc-100 mt-1" onClick={() => setOpen(false)}>
              Sign in
            </Link>
          )}
        </nav>
      )}
    </header>
  );
}
